import React, { Component } from "react";
import { Redirect, Route, withRouter, Switch } from "react-router-dom";
import {
	createCompensation,
	getUserSettings,
	saveCompensation,
} from "../../services/userService";
import { Page1 } from "./Compensation/Page1";
import { Page2 } from "./Compensation/Page2";
import { Page3 } from "./Compensation/Page3";
import { Page4 } from "./Compensation/Page4";
import { Field } from "react-jsonschema-form-validation";
import { Checkbox } from "../../components/common/FormInputs";

export const pathRoot = "/setupdata/compensation";

export const schema = {
	type: "object",
};

export const getOptionsElements = (
	optionsData,
	name,
	value,
	setValue,
	theme
) => {
	const optionsElements = optionsData.map((e, index) => {
		const keyName = `${name}${e.value}`;

		return (
			<>
				<Field
					type="radio"
					name={name}
					key={keyName}
					id={keyName}
					className={"hidden radioOption"}
					checked={value === e.value}
					onClick={() => setValue(e.value)}
				/>
				<Checkbox
					htmlFor={`${name}${e.value}`}
					key={`${keyName}Label`}
					label={e.label}
					checked={value === e.value}
				/>
			</>
		);
	});

	return optionsElements;
};

class Compensation extends Component {
	constructor(props) {
		super(props);

		let compensation = getUserSettings().compensation;

		if (compensation) {
		} else {
			compensation = createCompensation();
		}

		this.state = {
			compensation: { ...compensation },
			headerDetails: {
				title: "Compensation",
				pageCount: 3,
			},
		};
	}

	handleSave = (options) => {
		return new Promise((resolve, reject) => {
			options.complete = true;
			saveCompensation(options)
				.then(resolve)
				.catch((error) => {
					reject();
					this.handleSaveFailure(error);
				});
		});
	};

	handleSaveFailure = (error) => {
		console.error(`Error saving data in ${pathRoot}: `, error);
		// this.props.history.push("/dashboard");
	};

	render() {
		return (
			<Switch>
				<Route path={`${pathRoot}/1`}>
					<Page1
						compensation={this.state.compensation}
						handleSave={this.handleSave}
					/>
				</Route>
				<Route path={`${pathRoot}/2`}>
					<Page2
						compensation={this.state.compensation}
						handleSave={this.handleSave}
					/>
				</Route>
				<Route path={`${pathRoot}/3`}>
					<Page3
						compensation={this.state.compensation}
						handleSave={this.handleSave}
					/>
				</Route>
				<Route path={`${pathRoot}/4`}>
					<Page4
						compensation={this.state.compensation}
						handleSave={this.handleSave}
					/>
				</Route>

				<Redirect from={pathRoot} to={`${pathRoot}/1`} />
			</Switch>
		);
	}
}

export default withRouter(Compensation);
